import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class MFLEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Country", ListDataColumn.TEXT, "mflcountryname"),
                new ListColumn("City", ListDataColumn.TEXT, "mflcity"),
                new ListColumn("Street", ListDataColumn.TEXT, "mflstreet"),
                new ListColumn("Postcode", ListDataColumn.TEXT, "mflpostcode"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),
            ];

            const itemFinderTreeColumns=[
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Master File Location", ListDataColumn.TEXT, "masterfiledesc"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),
                
            ];

            super(items,itemFinderArrayColumns,itemFinderTreeColumns);


    }

}